import React, {FC, Fragment} from "react";
import cls from "../../shop.module.scss";
import Currency from "../../../shared/Currency";
import RemoveButton from "../RemoveButton";
interface IFooter {
    itemId: number;
    formattedBaseTotal: string;
    DeleteIntl: string
}
const Footer:FC<IFooter> = ({itemId, formattedBaseTotal, DeleteIntl}) => {
    return (
        <Fragment>
            <td className={`${cls["cart-table__column"]} ${cls["cart-table__column--total"]} ${cls["column--total-fms"]}`}>
                <span className={cls["cart-table__column-fm"]}>
                    <Currency value={formattedBaseTotal}/>
                </span>
            </td>
            <td className={`${cls["cart-table__column"]} ${cls["cart-table__column--remove"]}`}>
                <RemoveButton isAlternative={false} cartItemId={itemId} DeleteIntl={DeleteIntl}/>
            </td>
        </Fragment>
    )
}

export default Footer;
